import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import { useSearchParams } from 'react-router-dom';
import { shareStore } from '../Stores/ShareStore';
import {
  CourseOption,
  courseOptions,
  coursesFor,
  firstRun,
  optionFor,
  selectedProgramId,
} from './CourseOptions';
import CoursePicker from './CoursePicker';

export { awaitingCourse, courseCount, isCourseInvite, selectedRun } from './CourseOptions';

// After an invite goes out the admin may want the same page aimed at another
// course; this opens the catalog with its search ready to type into.
export const openCourseCatalog = (): void => {
  fromNullable(document.querySelector<HTMLElement>('[data-course-field-trigger]')).do((trigger) =>
    trigger.click(),
  );
};

// DVLP-7976: a course invite picks its course on the invite page. The URL stays
// the source of truth, so a reload keeps the choice, and the store re-aims the
// invite in place without dropping the participants already entered.
function CourseField() {
  const [searchParams, setSearchParams] = useSearchParams();

  const options = courseOptions(coursesFor(shareStore.state));
  const programId = selectedProgramId(shareStore.state);
  const selectedOption = programId.andThen((id) => optionFor(options, id));

  const aimAt = (id: number) => {
    const params = new URLSearchParams(searchParams);
    params.set('programId', String(id));
    setSearchParams(params, { replace: true });
  };

  // Picking a professor-led course aims at its earliest run; the run can then
  // be changed on the course card.
  const pick = (option: CourseOption): void => {
    firstRun(option).do((run) => aimAt(run.id));
  };

  return (
    <CoursePicker
      options={options}
      selected={selectedOption}
      runs={{ kind: 'choose-run', selectedProgramId: programId, onRunChange: aimAt }}
      catalog="inline"
      onPick={pick}
    />
  );
}

export default observer(CourseField);
